import { gql } from '@apollo/client';
export const PAYMENT_FIELDS = gql `
  fragment PaymentFields on Payment {
    id
    createdAt
    updatedAt
    clientId
    employeeId
    paymentRequestId
    paymentRequestItemId
    paymentRequestNum
    paymentRequestItemDesc
    employeeFirstName
    employeeLastName
    employeeUniqueId
    amount
    capYear
    capSegment
    adjustment
    status
    clientName
    currency
  }
`;
export const PAYROLL_FIELDS = gql `
  fragment PayrollFields on Payroll {
    id
    createdAt
    updatedAt
    clientId
    statementNum
    totalAmount
    parentId
    currencyTotals {
      currency
      amount
    }
  }
`;
export const PENDING_PAYMENTS = gql `
  ${PAYMENT_FIELDS}
  query PENDING_PAYMENTS($spec: PendingPaymentSpec!) {
    pendingPayments(spec: $spec) {
      ...PaymentFields
    }
  }
`;
export const PAYROLLS = gql `
  ${PAYROLL_FIELDS}
  query PAYROLLS($clientId: Int!) {
    payrolls(clientId: $clientId) {
      ...PayrollFields
    }
  }
`;
export const DOWNLOAD_PAYROLL = gql `
  query DOWNLOAD_PAYROLL($id: Int!, $exportId: Int!) {
    downloadPayroll(id: $id, exportId: $exportId)
  }
`;
export const PAYROLL_LINE_ITEMS = gql `
  query PAYROLL_LINE_ITEMS($payrollId: Int!) {
    payrollLineItems(payrollId: $payrollId) {
      id
      clientName
      employeeUniqueId
      employeeFirstName
      employeeLastName
      paymentRequestNum
      paymentRequestItemDesc
      amount
      currency
      capYear
      capSegment
    }
  }
`;
export const GENERATE_PAYROLL = gql `
  mutation GENERATE_PAYROLL($clientId: Int!) {
    generatePayroll(clientId: $clientId) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
